<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-08-21 10:45:20
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
     <div class="pageTitle">零售管理</div>

        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="零售出货记录" name="2">
                <el-form ref="form1" :model="form1" label-width="120px" :inline="true">
                    <el-form-item label="零售时间:">
                       <el-col :span="11">
                            <el-date-picker type="date" placeholder="开始时间" v-model="form1.start_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="结束时间" v-model="form1.end_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="单号:">
                        <el-input v-model="form1.stock_out_sn" clearable ></el-input>
                    </el-form-item>
                         <el-form-item label="门店/经销商:">
                                <el-col :span="16">
                                    <el-input v-model="form1.from_sn" clearable></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>
                            </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                        <el-button type="primary" @click="exprotData()">导出</el-button>

                    </el-form-item>
                </el-form>
                 <span style="margin-left: 40px;margin-right: 10px">零售总数：</span><span style="color: red;">{{stock_in_num}}</span>
                <el-table
                        ref="multipleTable"
                        :data="tableData1"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin: 20px">
                    <el-table-column
                            prop=""
                            label="序号"
                            width="50"
                            fixed>
                            <template slot-scope="scope">
                            {{scope.$index}}
                        </template>
                    </el-table-column>
                     <el-table-column
                            prop="stock_out_sn"
                            label="单号"
                            show-overflow-tooltip>
                    </el-table-column>
                     <el-table-column
                            prop="from_sn"
                            label="门店/经销商编号"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                    <el-table-column
                            prop="from_name"
                            label="门店/经销商名称"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                   
       
                    <el-table-column
                            prop="real_stock_out_num"
                            label="零售数量"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                    <el-table-column
                            prop="created_at"
                            label="零售时间"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                     <el-table-column
                            prop="remarks"
                            label="备注"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                   
                    <el-table-column
                            prop=""
                            label="操作"
                            width="240"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                        <el-button type="text" @click="getDetail(scope.row)">查看明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[10, 15, 20, 25]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination>

            </el-tab-pane>
            <el-tab-pane label="零售退货记录" name="3">
         
               <el-form ref="form2" :model="form2" label-width="120px" :inline="true">
                    <el-form-item label="退货时间:">
                       <el-col :span="11">
                            <el-date-picker type="date" placeholder="开始时间" v-model="form2.start_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                        <el-col class="line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-date-picker type="date" placeholder="结束时间" v-model="form2.end_time"
                                            style="width: 100%;"></el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="退货单号:">
                        <el-input v-model="form2.return_goods_sn" clearable ></el-input>
                    </el-form-item>
                 <el-form-item label="门店/经销商:">
                                <el-col :span="16">
                                    <el-input v-model="form2.to_sn" clearable></el-input>
                                </el-col>
                                <el-col :span="4" style="margin-left: 10px;">
                                    <el-button type="primary" @click="selectType()">选择</el-button>
                                </el-col>
                            </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch()">搜索</el-button>
                        <el-button type="primary" @click="exprotData()">导出</el-button>

                    </el-form-item>
                </el-form>
                      <span style="margin-left: 40px;margin-right: 10px">退货总数：</span><span style="color: red;">{{stock_in_num}}</span>
                  <el-table
                        ref="multipleTable"
                        :data="tableData2"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%;margin: 20px">
                    <el-table-column
                            prop=""
                            label="序号"
                            fixed>
                            <template slot-scope="scope">
                            {{scope.$index}}
                        </template>
                    </el-table-column>
                         <el-table-column
                            prop="return_goods_sn"
                            label="退货单号"
                            show-overflow-tooltip>
                    </el-table-column>
                     <el-table-column
                            prop="to_sn"
                            label="门店/经销商编号"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                    <el-table-column
                            prop="to_name"
                            label="门店/经销商名称"
                            show-overflow-tooltip>
                    
                    </el-table-column>
               
       
                    <el-table-column
                            prop="return_goods_num_total"
                            label="退货数量"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                    <el-table-column
                            prop="created_at"
                            label="退货时间"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                     <el-table-column
                            prop="remarks"
                            label="备注"
                            show-overflow-tooltip>
                    
                    </el-table-column>
                   
                    <el-table-column
                            prop=""
                            label="操作"
                            width="240"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                        <el-button type="text" @click="getDetail(scope.row)">查看明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
              
      <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[10, 15, 20, 25]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>
        
  <!--选择经销商-->
        <selectRole
                v-if="selectRoleDialog"
                 @pushData='getRole'
                v-on:handleClose='selectRoleDialog = false'>
        </selectRole>
     <el-dialog
  title="查看明细"
  :visible.sync="detailDialog"
  width="70%"
  >
    <!-- <el-button @click="exportDetail">导出明细</el-button> -->

    <el-table
              ref="multipleTable"
              :data="tableData3"
              v-loading="loading"
              border
              stripe
              style="width: 100%;margin: 20px"
            >
              <el-table-column prop label="序号" fixed >
                   <template slot-scope="scope">
                 {{scope.$index}}
                </template>
              </el-table-column>
              <el-table-column prop='logistics_code' label="物流码" show-overflow-tooltip></el-table-column>
              <el-table-column prop='code_name' label="标签类型" show-overflow-tooltip ></el-table-column>
              <el-table-column prop='product_sn' label="产品编号" show-overflow-tooltip ></el-table-column>
              <el-table-column prop='product_name' label="产品名称" show-overflow-tooltip ></el-table-column>          
              <el-table-column prop='product_specs' label="产品规格" show-overflow-tooltip ></el-table-column>
              <el-table-column prop='real_stock_out_num' label="零售数量" show-overflow-tooltip v-if='activeName==2'></el-table-column>
              <el-table-column prop='real_return_goods_num' label="退货数量" show-overflow-tooltip v-if='activeName==3'></el-table-column>
              <el-table-column prop='created_at' label="退货时间" width="180" show-overflow-tooltip v-if='activeName==3'></el-table-column>
              <el-table-column prop='created_at' label="零售时间" width="180" show-overflow-tooltip v-if='activeName==2'></el-table-column>
              <el-table-column prop='source' label="来源" width="180" show-overflow-tooltip fixed="right">
                  <template slot="header" slot-scope="scope">
                       <el-tooltip class="item" effect="dark"  placement="top-start">
                            <div slot="content">l.零售出货:经销商/门店通过零售扫描卖出的产品;<br/>2.库存盘点:经销商/门店在盘点时未扫描到的产品均视为已零售;<br/>3.用户扫码:消费者扫描了产品上的二维码则视为已零售</div>
                            <span>来源 <span style='display: inline-block;border: 1px solid #eee;border-radius: 50%;width: 20px;text-align: center;height: 20px;line-height: 20px;'>?</span></span>
                        </el-tooltip>
                    </template>
              </el-table-column>
            </el-table>
  <span slot="footer" class="dialog-footer">
    <el-button @click="detailDialog = false">取 消</el-button>
    <el-button type="primary" @click="detailDialog = false">确 定</el-button>
  </span>
</el-dialog>
    </div>
</template>

<script>     
    import selectRole from '../../common/selectRole';

    export default {
        name: "goods-onput",
        data() {
            return {
                detailDialog:false,
                loading:false,
                activeName: '2',
                form1:{
                    stock_out_sn:'',
                 
                    start_time:"",
                    end_time:"",
                    from_sn:""
                                    },
                form2:{
                    product_sn:'',
                    product_name:'',
                    return_goods_sn:"",
                    custType:'',
                    to_sn:""
                },
                tableData1: [
                    {},
                    {},
                    {},
                    {},
                    {},
                ],
                tableData2: [
                    {},
                    {},
                    {},
                    {},
                    {},
                ],
                tableData3:[],
                selectRoleDialog:false,
                type:"",
                stock_in_num:0,
                real_stock_in_num:0,
                //分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
                //分页
                pageNo2: 1,//页码
                pageSize2: 20,//每页现实的条数
                totalSize2: 0,//总条数
                sn:''
            }
        },
        methods: {
            onSearch(){
                this.loading=true
                if(this.activeName==2){
                    let beginstr = "",
                            endstr = "";
                        if (this.form1.start_time) {
                            beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD");
                        }
                        if (this.form1.end_time) {
                            endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                        }
                    this.$get('logistics','/retails.outstocks',{
                        start_time:beginstr,
                        end_time:endstr,
                        from_type:this.type,
                        stock_out_sn:this.form1.stock_out_sn,
                        per_page:this.pageSize1,
                        page:this.pageNo1,
                        from_sn:this.form1.from_sn
                    }).then(res=>{
                     this.loading=false
                    this.tableData1=res.data
                    this.totalSize1=res.meta.total
                    this.stock_in_num=res.real_stock_out_num
                    this.real_stock_in_num=res.real_stock_out_num
                    })
                }else{
                    let beginstr = "",
                            endstr = "";
                        if (this.form2.start_time) {
                            beginstr = this.moment(this.form2.start_time).format("YYYY-MM-DD");
                        }
                        if (this.form2.end_time) {
                            endstr = this.moment(this.form2.end_time).format("YYYY-MM-DD");
                        }
                    this.$get('logistics','/retails.returngoods',{
                        start_time:beginstr,
                        end_time:endstr,
                        from_type:this.type,
                        return_goods_sn:this.form2.return_goods_sn,
                        per_page:this.pageSize2,
                        page:this.pageNo2,
                        to_sn:this.form2.to_sn
                    }).then(res=>{
                     this.loading=false
                    this.tableData2=res.data
                    this.totalSize2=res.meta.total
                    this.stock_in_num=res.real_return_goods_num
                    this.real_stock_in_num=res.real_stock_out_num
                    })
                }
            },
               selectType() {
                this.selectRoleDialog = true;
            },
            getRole(data){
                if(data.dealer_sn){
                    this.type=2
                    if(this.activeName==2){
                        this.form1.from_sn=data.dealer_sn
                    }else{
                        this.form2.to_sn=data.dealer_sn

                    }
                }else{
                    this.type=3
                       if(this.activeName==2){
                        this.form1.from_sn=data.shop_sn
                    }else{
                        this.form2.to_sn=data.shop_sn

                    }
                }
            },
            exprotData(){
                  let beginstr = '', endstr = '',access_tokens='';
     
                if(this.activeName==2){
                            if(this.form1.start_time){
                    beginstr = this.moment(this.form1.start_time).format("YYYY-MM-DD")
                }
                if(this.form1.end_time){
                    endstr = this.moment(this.form1.end_time).format("YYYY-MM-DD");
                }
                access_tokens = localStorage.getItem('access_tokens');
                console.log( this.$Base_Export+
                    +'/retails.outstocks.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&from_type=' +
                    this.type +'&from_sn=' + this.form1.from_sn + '&stock_out_sn=' + this.form1.stock_out_sn + '&lang=' + ''+'&signature='+ this.$md5(access_tokens))
                    // return;
                window.open( this.$Base_Export+
                    +'/retails.outstocks.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&from_type=' +
                    this.type +'&from_sn=' + this.form1.from_sn + '&stock_out_sn=' + this.form1.stock_out_sn + '&lang=' + ''+'&signature='+ this.$md5(access_tokens)

                ) 

                }else{
                 if(this.form2.start_time){
                    beginstr = this.moment(this.form2.start_time).format("YYYY-MM-DD")
                }
                if(this.form2.end_time){
                    endstr = this.moment(this.form2.end_time).format("YYYY-MM-DD");
                }
                let  access_tokens = localStorage.getItem('access_tokens');
                console.log(url+process.env.VUE_APP_URL
                    +'/retails.returngoods.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&to_type=' +
                    this.type +'&to_sn=' + this.form2.to_sn + '&return_goods_sn=' +this.form2.return_goods_sn+ '&lang=' + ''+'&signature='+ this.$md5(access_tokens))
                    // return;
                window.open(url+process.env.VUE_APP_URL
                    +'/retails.returngoods.export?start_time=' + beginstr +'&end_time=' + endstr +'&is_export=1'+ '&to_type=' +
                    this.type +'&to_sn=' + this.form2.to_sn + '&return_goods_sn=' +this.form2.return_goods_sn+ '&lang=' + ''+'&signature='+ this.$md5(access_tokens)
                )
                }
                
            },
            getDetail(data){
                this.loading=true
                this.tableData3=[]
                if(data.return_goods_sn){
                    this.sn=data.return_goods_sn
                     this.$get('logistics','/retails.returngoods/datas',{
                        return_goods_sn:data.return_goods_sn
                    }).then(res=>{
                this.detailDialog=true
                this.loading=false
                        this.tableData3=res.data
                    }).catch(error=>{
                this.loading=false
                this.$message({
                    type:'error',
                    message:error.message
                })
                    })
                }else{
                    console.log(data)
                    this.sn=data.stock_out_sn
                     this.$get('logistics','/retails.outstocks/datas',{
                        stock_out_sn:data.stock_out_sn
                    }).then(res=>{
                         this.detailDialog=true
                        this.loading=false

                        this.tableData3=res.data
                    }).catch(error=>{
                this.loading=false
                this.$message({
                    type:'error',
                    message:error.message
                })
                    })
                }
            },           
            handleClick(tab) {
                this.onSearch()
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.pageNo1 = 1;
                this.onSearch()
            },
            handleCurrentChange1(val) {
                this.pageNo1 = val;
                this.onSearch()
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.pageNo2 = 1;
                this.onSearch()
            },
            handleCurrentChange2(val) {
                this.pageNo2 = val;
                this.onSearch()
            },
       
        },
        created() {
            this.onSearch()
        },
        components:{
            selectRole
        }
    }
</script>

<style lang="scss" scoped>
    .block{
        height: 100px;
        line-height: 24px;
        background-color: #eee;
        padding-left: 20px;
        margin-bottom: 20px;
    }
/deep/.el-table .cell.el-tooltip{
    height: 30px;
} 
</style>